import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { useTranslation } from "react-i18next"
import { Errors } from "schema"
import { toast } from "sonner"
import { getCampaignQueryKey } from "../lib/campaignQuery"

type Props = {
  campaignId: string
  templateId: string
}

export const useUpdateCampaignTemplateStatusMutation = ({ campaignId, templateId }: Props) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (status: "active" | "inactive") => {
      const { data } = await axios.patch(`/campaigns/${campaignId}/templates/${templateId}`, {
        status,
      })
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(campaignId) })

      toast.success(t("campaigns.templates.whatsapp.actions.updateSuccess"))
    },
    onError: (error) => {
      const key = axios.isAxiosError(error) ? error.response?.data?.error?.key : undefined
      toast.error(
        t(
          key === Errors.CAMPAIGN_DEFAULT_LANGUAGE_TEMPLATE_REQUIRED
            ? "campaigns.templates.whatsapp.campaign.defaultLanguageTemplateRequired"
            : "campaigns.templates.whatsapp.actions.updateFailed",
        ),
      )
    },
  })
}
